import { checkForMutationSuccess } from 'API/checkForMutationSuccess';
import {
  useCreateAchDisbursementMutation,
  useUpdateAchDisbursementMutation,
  useDeleteAchDisbursementMutation,
  useCreateACHAccountMutation,
} from 'API/order/escrow/AchDisbursementAPI';
import { IACHDisbursementFormData } from 'types/order/escrow/achDisbursements/IACHDisbursementFormData';

export const useProcessACH = () => {
  const [onCreateACH] = useCreateAchDisbursementMutation();
  const [onCreateACHAccount] = useCreateACHAccountMutation();
  const [onUpdateACH] = useUpdateAchDisbursementMutation();
  const [onDeleteACH] = useDeleteAchDisbursementMutation();
  return async (escrowFileId: string, orderId: string, achFormData: IACHDisbursementFormData) => {
    const {
      isNew,
      isDeleting,
      type,
      account,
      wellsFargoTransactionNumber,
      amountCents,
      holdback = false,
      category,
      ...achForm
    } = achFormData;
    if (isDeleting) {
      return onDeleteACH({ achId: achForm.id, orderId });
    }


    let achAccountId = account?.id;
    const ableToCreateAccount = account?.accountNumber && account.accountNumberConfirmation && account.accountType && account.name && account.routingNumber
    if (!achAccountId && account && ableToCreateAccount) {
      const { accountType, ...rest } = account;
      const result = await onCreateACHAccount({ type: accountType, ...rest });
      if (checkForMutationSuccess(result, 'creating ach account')) {
        achAccountId = result.data.id;
      } else {
        return result;
      }
    }

    const ach = {
      ...achForm,
      achAccountId,
      wellsFargoTransactionNumber,
      amountCents,
      holdback,
      category,
    };

    if (isNew) {
      return onCreateACH({ escrowFileId, orderId, ach });
    }

    return onUpdateACH({ orderId, ach });
  };
};
